import { useCallback } from "react";
import { TellescopeModelFromName } from "@tellescope/tanstack-query";
import { formatCurrency, formatDateTime } from "@tellescope/utils";
import { useTranslation } from "react-i18next";

export interface PurchaseDisplayFields {
  amount: string;
  date: string;
  description: string;
}

/**
 * Formats a `purchases` record into the display strings shared by the payments list rows and the
 * single-purchase detail view, so both render a purchase identically.
 */
export const usePurchaseDisplay = () => {
  const { t } = useTranslation("contacts");

  return useCallback(
    (purchase: TellescopeModelFromName<"purchases">): PurchaseDisplayFields => ({
      amount: formatCurrency(purchase.cost.amount, purchase.cost.currency, { fromSmallestUnit: true }),
      date: purchase.processedAt ? formatDateTime(purchase.processedAt, "MM/DD/YYYY") : t("Date not specified"),
      description: purchase.description ?? "",
    }),
    [t]
  );
};
